import { FunctionComponent, ReactNode } from 'react';

import HeaderCaret from '@/components/atom/icon/arrow/HeaderCaret';
import {
  AppHeaderContainer,
  AppHeaderExtendedWrapper,
  AppHeaderRightButtons,
  AppHeaderWrapper,
  LeftButton,
  LeftButtonWrapper,
  Title,
} from '@/components/molecules/app-header/styles';

import SearchButton from './search-button';
import ShareButton from './share-button';

interface AppHeaderShareProps {
  onClick: () => void;
}

export interface AppHeaderProps {
  children?: ReactNode;
  title?: string | ReactNode;
  color?: string;
  hasSearchButton?: () => void;
  hasShareButton?: AppHeaderShareProps;
  onClickBackButton?: () => void;
  left?: boolean;
  etcButton?: ReactNode;
}

const AppHeader: FunctionComponent<AppHeaderProps> = ({
  children,
  title,
  color,
  hasSearchButton,
  hasShareButton,
  onClickBackButton,
  left,
  etcButton,
}) => {
  return (
    <AppHeaderContainer id={'appHeader'}>
      <AppHeaderWrapper color={color} left={left}>
        {!left && onClickBackButton && (
          <LeftButtonWrapper>
            <LeftButton onClick={() => onClickBackButton()}>
              <HeaderCaret />
            </LeftButton>
          </LeftButtonWrapper>
        )}
        {title && <Title>{title}</Title>}
        <AppHeaderRightButtons>
          {hasSearchButton && <SearchButton onClick={hasSearchButton} />}
          {hasShareButton && <ShareButton onClick={hasShareButton.onClick} />}
          {etcButton && etcButton}
        </AppHeaderRightButtons>
      </AppHeaderWrapper>
      <AppHeaderExtendedWrapper>{children}</AppHeaderExtendedWrapper>
    </AppHeaderContainer>
  );
};

export default AppHeader;
